// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"93b1acf7b1f8de5b0cc1","293":"6817733753241a13769a"}[chunkId] + ".js";
};